import { createSlice } from "@reduxjs/toolkit";
import {
  followUserAsync,
  unfollowUserAsync,
  updateUserReducer,
} from "./usersSlice";

const initialState = {
  user: JSON.parse(localStorage.getItem("currentUser")) || null,
  isAuthenticated: JSON.parse(localStorage.getItem("isAuthenticated")) || false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("currentUser", JSON.stringify(action.payload));
      localStorage.setItem("isAuthenticated", "true");
    },
    loginFailure: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("currentUser");
      localStorage.removeItem("isAuthenticated");
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("currentUser");
      localStorage.removeItem("isAuthenticated");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateUserReducer, (state, action) => {
      if (state.user && state.user._id === action.payload.id) {
        state.user = { ...state.user, ...action.payload.updatedUser };
        localStorage.setItem("currentUser", JSON.stringify(state.user));
      }
    });

    builder.addCase(followUserAsync.fulfilled, (state, action) => {
      const { followerId, followingId } = action.payload;
      if (state.user && state.user._id === followerId) {
        state.user.following = [...state.user.following, followingId];
        localStorage.setItem("currentUser", JSON.stringify(state.user));
      }
      if (state.user && state.user._id === followingId) {
        state.user.followers = [...state.user.followers, followerId];
        localStorage.setItem("currentUser", JSON.stringify(state.user));
      }
    });

    builder.addCase(unfollowUserAsync.fulfilled, (state, action) => {
      const { followerId, followingId } = action.payload;
      if (state.user && state.user._id === followerId) {
        state.user.following = state.user.following.filter(
          (id) => id !== followingId
        );
        localStorage.setItem("currentUser", JSON.stringify(state.user));
      }
      if (state.user && state.user._id === followingId) {
        state.user.followers = state.user.followers.filter(
          (id) => id !== followerId
        );
        localStorage.setItem("currentUser", JSON.stringify(state.user));
      }
    });
  },
});

export const { loginSuccess, loginFailure, logout } = authSlice.actions;
export default authSlice.reducer;
